import React, { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import sanityClient from "../../sanityClient"
import { FaQuestionCircle, FaBook } from "react-icons/fa"
import { faqs } from "./FAQs"
import { FaPaperPlane } from "react-icons/fa"
import useLogging from "../../hooks/useLogging"

const Header = ({ setSelectedFaq }) => {
	const [searchInput, setSearchInput] = useState("")
	const [articles, setArticles] = useState([])
	const [filteredResults, setFilteredResults] = useState([])
	const navigate = useNavigate()
	const logging = useLogging()
	useEffect(() => {
		sanityClient
			.fetch(
				`*[_type == "post"]{
          title,
          slug,
          body
        }`
			)
			.then(data => setArticles(data))
			.catch(error => {
				logging.warn("Error fetching articles:", {
					error: error.message,
					stack: error.stack
				})
			})
		// `logging` is a fresh object each render (useLogging returns inline object); mount-only fetch.
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	useEffect(() => {
		const combinedResults = [
			...articles.map(article => ({ ...article, type: "article" })),
			...faqs.map(faq => ({ ...faq, type: "faq" }))
		]

		setFilteredResults(
			combinedResults.filter(
				item =>
					item.title?.toLowerCase().includes(searchInput.toLowerCase()) ||
					item.question?.toLowerCase().includes(searchInput.toLowerCase())
			)
		)
	}, [searchInput, articles])

	const handleSearchChange = event => {
		setSearchInput(event.target.value)
	}

	const handleResultClick = item => {
		if (item.type === "article") {
			navigate(`/support/articles/${item.slug.current}`)
		} else {
			setSelectedFaq(item.question)
			document.getElementById("faqs").scrollIntoView({ behavior: "smooth" })
		}
	}

	return (
		<div className="relative bg-blue-50 py-6 sm:py-9 lg:py-12">
			<div className="absolute top-8 right-8">
				<a
					href="https://portal.usepylon.com/oncore/forms/support-form"
					target="_blank"
					rel="noopener noreferrer"
					className="block"
				>
					<div className="bg-customBlue hover:bg-customBlue-dark text-white py-2 px-4 rounded-md text-center cursor-pointer flex items-center justify-center space-x-2">
						<FaPaperPlane />
						<span>Submit Ticket</span>
					</div>
				</a>
			</div>
			<div className="relative mx-auto max-w-7xl grid grid-cols-1 lg:grid-cols-2 gap-8 px-6 lg:px-8 pt-12">
				<div className="flex flex-col justify-center max-w-lg mx-auto">
					<h1 className="text-4xl font-extrabold tracking-tight text-gray-700 sm:text-5xl font-manrope">
						How can we help you?
					</h1>
					<div className="mt-8 flex flex-col">
						<input
							type="text"
							placeholder="Search..."
							className="w-full py-3 px-4 rounded-md border border-gray-300 shadow-sm focus:border-indigo-500 focus:ring focus:ring-indigo-500 focus:ring-opacity-50"
							value={searchInput}
							onChange={handleSearchChange}
						/>
						{searchInput && (
							<div className="mt-4 bg-white p-4 rounded-md shadow-md">
								{filteredResults.length > 0 ? (
									filteredResults.map((item, index) => (
										<div
											key={index}
											onClick={() => handleResultClick(item)}
											className="py-2 border-b last:border-b-0 cursor-pointer"
										>
											<div className="flex items-center">
												{item.type === "article" ? (
													<FaBook className="mr-2 text-customBlue" />
												) : (
													<FaQuestionCircle className="mr-2 text-customBlue" />
												)}
												{item.title || item.question}
											</div>
										</div>
									))
								) : (
									<div>
										<a
											href="https://portal.usepylon.com/oncore/forms/support-form"
											target="_blank"
											rel="noopener noreferrer"
											className="block mt-2 text-customBlue hover:text-customBlue-dark"
										>
											No post is found - please open a support ticket
										</a>
									</div>
								)}
							</div>
						)}
						{/* Add margin below the button */}
						<div className="mt-8"></div> {/* This adds spacing below the input */}
					</div>
				</div>
				<div className="flex items-center justify-center lg:justify-end-16">
					<img
						className="w-auto h-auto max-h-80"
						src="/images/oncare_logo.png"
						alt="Oncore"
					/>
				</div>
			</div>
		</div>
	)
}

export default Header
